import * as actionTypes from "../action-types";

const initialState = {
    //! Yatra
    yatraData: [],
    yatraDetailsData: {},

    //! Product
    productCategoryData: [],
    productData: [],
    productCartData: [],

    //! Puja
    pujaData: [],
};

const ecommerceReducer = (state = initialState, actions) => {
    const { payload, type } = actions;

    switch (type) {
        //! Yatra
        case actionTypes.SET_YATRA:
            return { ...state, yatraData: payload };

        case actionTypes.SET_YATRA_DETAILS:
            return { ...state, yatraDetailsData: payload };

        //! Product
        case actionTypes.SET_PRODUCT_CATEGORY:
            return { ...state, productCategoryData: payload };

        case actionTypes.SET_PRODUCT:
            return { ...state, productData: payload };

        case actionTypes.SET_PRODUCT_CART:
            return { ...state, productCartData: payload };

        //! Puja
        case actionTypes.SET_PUJA:
            return { ...state, pujaData: payload };

        default:
            return state;
    }
};

export default ecommerceReducer;